module.exports = ".btn-xs {\n    color: #2968ed;\n  }"